/**
 * Algolia Insights Event Tracking — Simple Lighting
 * Exposes window.SlAlgoliaEvents with 6 tracking functions.
 * Loaded defer — runs after DOM parsed, never blocks rendering.
 * All calls wrapped in try/catch — analytics must never break the page.
 */
(function() {
  'use strict';

  function isReady() {
    return typeof aa === 'function' && window.SlAlgoliaConfig && window.SlAlgoliaConfig.indexName;
  }

  function getIndex() {
    return window.SlAlgoliaConfig.indexName;
  }

  /* 1. Product clicked from search results (has queryID) */
  function trackSearchClick(objectID, queryID, position) {
    try {
      if (!isReady() || !queryID) return;
      aa('clickedObjectIDsAfterSearch', {
        index: getIndex(),
        eventName: 'Product Clicked After Search',
        queryID: queryID,
        objectIDs: [String(objectID)],
        positions: [parseInt(position, 10) || 1]
      });
    } catch(e) { /* silent */ }
  }

  /* 2. Product clicked from collection/browse (no queryID) */
  function trackBrowseClick(objectID) {
    try {
      if (!isReady()) return;
      aa('clickedObjectIDs', {
        index: getIndex(),
        eventName: 'Product Clicked',
        objectIDs: [String(objectID)]
      });
    } catch(e) { /* silent */ }
  }

  /* 3. Added to cart after arriving from search */
  function trackSearchConversion(objectID, queryID) {
    try {
      if (!isReady() || !queryID) return;
      aa('convertedObjectIDsAfterSearch', {
        index: getIndex(),
        eventName: 'Product Added to Cart After Search',
        queryID: queryID,
        objectIDs: [String(objectID)]
      });
    } catch(e) { /* silent */ }
  }

  /* 4. Added to cart from collection/browse */
  function trackBrowseConversion(objectID) {
    try {
      if (!isReady()) return;
      aa('convertedObjectIDs', {
        index: getIndex(),
        eventName: 'Product Added to Cart',
        objectIDs: [String(objectID)]
      });
    } catch(e) { /* silent */ }
  }

  /* 5. Purchase completed (order confirmation) */
  function trackPurchase(objectIDs) {
    try {
      if (!isReady() || !objectIDs || !objectIDs.length) return;
      aa('purchasedObjectIDs', {
        index: getIndex(),
        eventName: 'Products Purchased',
        objectIDs: objectIDs.map(String)
      });
    } catch(e) { /* silent */ }
  }

  /* 6. Product page viewed */
  function trackProductView(objectID) {
    try {
      if (!isReady()) return;
      aa('viewedObjectIDs', {
        index: getIndex(),
        eventName: 'Product Viewed',
        objectIDs: [String(objectID)]
      });
    } catch(e) { /* silent */ }
  }

  /* 7. Batch product views (recommend widgets) */
  function trackProductsViewed(objectIDs, eventName) {
    try {
      if (!isReady() || !objectIDs || !objectIDs.length) return;
      aa('viewedObjectIDs', {
        index: getIndex(),
        eventName: eventName || 'Products Viewed',
        objectIDs: objectIDs.map(String).slice(0, 20)
      });
    } catch(e) { /* silent */ }
  }

  window.SlAlgoliaEvents = {
    trackSearchClick: trackSearchClick,
    trackBrowseClick: trackBrowseClick,
    trackSearchConversion: trackSearchConversion,
    trackBrowseConversion: trackBrowseConversion,
    trackPurchase: trackPurchase,
    trackProductView: trackProductView,
    trackProductsViewed: trackProductsViewed
  };
})();
